import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import useDarkMode from '../hooks/useDarkMode';
import useScrollProgress from '../hooks/useScrollProgress';
import Hero from '../sections/Hero';
import About from '../sections/About';
import Services from '../sections/Services';
import Portfolio from '../sections/Portfolio';
import Process from '../sections/Process';
import Testimonials from '../sections/Testimonials';
import Stats from '../sections/Stats';
import Contact from '../sections/Contact';
import CTA from '../sections/CTA';
import LazySection from '../components/LazySection';

const SinglePage = () => {
  const { darkMode, toggleDarkMode } = useDarkMode();
  const scrollProgress = useScrollProgress();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      {/* Scroll Progress Bar */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: `${scrollProgress}%`,
          height: '4px',
          background: 'linear-gradient(to right, #667eea, #764ba2)',
          zIndex: 9999,
          transition: 'width 0.3s ease'
        }}
      />

      {/* Dark Mode Toggle */}
      <button
        onClick={toggleDarkMode}
        style={{
          position: 'fixed',
          top: '80px',
          right: '20px',
          zIndex: 1000,
          background: darkMode ? 'linear-gradient(135deg, #667eea, #764ba2)' : 'linear-gradient(135deg, #f39c12, #f1c40f)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          transition: 'all 0.3s ease'
        }}
        aria-label="Toggle dark mode"
      >
        {darkMode ? <FaSun color="white" size={20} /> : <FaMoon color="white" size={20} />}
      </button>

      <Hero scrollToSection={scrollToSection} />
      <LazySection><About /></LazySection>
      <LazySection><Services /></LazySection>
      <LazySection><Portfolio /></LazySection>
      <LazySection><Process /></LazySection>
      <LazySection><Testimonials /></LazySection>
      <LazySection><Stats /></LazySection>
      <LazySection><Contact /></LazySection>
      <LazySection><CTA scrollToSection={scrollToSection} /></LazySection>
    </>
  );
};

export default SinglePage;
